import { render, staticRenderFns } from "./AssignmentsFieldsModal.vue?vue&type=template&id=f6c5889a&scoped=true&"
import script from "./AssignmentsFieldsModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentsFieldsModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsFieldsModal.vue?vue&type=style&index=0&id=f6c5889a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c5889a",
  null
  
)

export default component.exports